<template>
	<div class="footer-box">
	  <div class="container footer-content">
		  <div class="row">
			  <div class="col-lg-3 col-sm-6 col-xs-6 xs-percentage2-top">
				  <img src="../assets/img/logo.png" class="logo-img" alt="" srcset="">
				  <div class="gongsi"> 
					  <div class="tel-text">联系电话</div>
					  <div class="tel-num">029-89531063</div>
				  </div>
				  <div class="beian">
					<div class="tel-text">服务热线</div>
					<div class="tel-num">400-0553-888</div>
				  </div>
				  
				</div>
			  <div class="col-lg-3 col-sm-6 col-xs-6 flex-col flex-item-center xs-left xs-percentage2-top" v-for="(item,index) in menuList" :key="index">
				  <div class="footer-menu">
					  <div class="footer-item-title">{{ item.title }}</div>
					  <div class="footer-item cursor-pointer" :class="{'more-text':item1.text=='更多'}"
					   v-for="(item1,index1) in item.list" :key="index1"
						@click="scrollToAnchor(item1)">
						  {{ item1.text }}
					  </div>
				  </div>
			  </div>
			  <div class="col-lg-3 col-sm-6 col-xs-6 flex-item-center flex-space-between xs-left xs-percentage2-top">
				<div class="text-center">
					<img src="../assets/img/code1.png" class="code-img" alt="" srcset="">
				  	<div class="code-text">惠宾科技</div>
				  	<div class="code-text1">扫一扫关注官方公众号</div>
				</div>
				<div class="text-center">
					<img src="../assets/img/code2.png" class="code-img" alt="" srcset="">
				  	<div class="code-text">惠宾健康</div>
				  	<div class="code-text1">扫一扫关注官方公众号</div>
				</div>
			  </div>
		  </div>
		  <div class="address-box">
			  <span class="mr-5">版权所有：陕公网COPYRIGHT</span>
			  <span class="mr-5">@2024陕西惠宾电子科技有限公司</span>
			  <span>陕ICP证123456789号</span>
		  </div>
	  </div>
	</div>
  </template>
  
  <script>

  export default {
	  name:"bottomFooter",
	  data() {
		  return {
			  menuList:[
				  {
					  title:"产品与解决方案",
					  list:[
						  {
							  text:"互联网医院",	
							  id:"3",
							  url:"/productCenter"
						  },
						  {
							  text:"门诊预约挂号系统",	
							  id:"1",
							  url:"/productCenter"
						  },
						  {
							  text:"医院智能排队叫号系统",	
							  id:"2",	
							  url:"/productCenter"
						  },
						  {
						  	text:"门诊综合服务平台/外联平台",
							id:"4",	
							url:"/productCenter"
						  },
						  {
						  	text:"更多",
							id:"0",	
							url:"/productCenter"
						  }
					  ],
				  },
				  {
					  title:"关于我们",
					  list:[
						  {
							  text:"公司简介",	
							  id:"13",
							  url:"/about"
						  },
						  {
							  text:"发展历程",		
							  id:"14",
							  url:"/about"
						  },
						  {
							  text:"资质荣誉",		
							  id:"15",
							  url:"/about"
						  },
						  {
							  text:"联系我们",		
							  id:"16",
							  url:"/about"
						  }
					  ],
				  },
			  ]
		  }
	  },
	  
	  methods: {
		  scrollToAnchor(item) {
			console.log(item);
			this.$emit("active",item)
			if(!item.url){
			return false;
			}
			this.$router.push({
				path: item.url,
				query:{
					id:item.id
				}
			});
		  },
	  },
  }
  </script>
  
  <style scoped lang="scss">
  .footer-box{
	  width: 100%;
	  padding-top: 3.8rem;
	  padding-bottom: 2rem;
	  background-color: #0E1C42;
  }
  .logo-img{
	  width: 16rem;
	  height: 7rem;
  }
  .gongsi{
	  margin-top:1.5rem ;
	  font-family: Microsoft YaHei, Microsoft YaHei;
	  font-weight: 400;
	  font-size: 1.6rem;
	  color: #989faf;
  }
  .tel-num{
	color: #ffffff;
	font-weight: 700;
  }
  .beian{
	  margin-top: 0.5rem;
	  font-family: Microsoft YaHei, Microsoft YaHei;
	  font-weight: 400;
	  font-size: 1.6rem;
	  color: #989faf;
  }
  .footer-menu{
	//   width: 18rem;
	  text-align: left;
	  .footer-item-title{
		  font-family: Microsoft YaHei, Microsoft YaHei;
		  font-weight: 400;
		  font-size: 1.8rem;
		  color: #ffffff;
		  margin-bottom: 1.6rem;
	  }
	  .footer-item{
		  margin-top: 0.6rem;
		  font-family: Microsoft YaHei, Microsoft YaHei;
		  font-weight: 400;
		  font-size: 1.6rem;
		  color: #989faf;
		  &:hover{
			  color: #ffffff;
		  }
	  }
	  
	.more-text{
		color: #ffffff;
	}
  }
  .code-img{
	  width: 11rem;
	  height: 11rem;
  }
  .code-text{
	  margin-top: 1rem;
	  font-family: Microsoft YaHei, Microsoft YaHei;
	  font-weight: 400;
	  font-size: 1.4rem;
	  color: #989faf;
  }
  .code-text1{
	  margin-top: 1rem;
	  font-family: Microsoft YaHei, Microsoft YaHei;
	  font-weight: 400;
	  font-size: 1.2rem;
	  color: #989faf;
  }
  .address-box{
	  margin-top: 1.5rem;
	  font-family: Microsoft YaHei, Microsoft YaHei;
	  font-weight: 400;
	  font-size: 12px;
	  color: #989faf;
  }
  .footer-content{
	display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }
  </style>